import type { JSX } from 'react';

import { ClientTPRMApi } from 'Api/TPRM/TPRMApi';
import { ClientUcrmApi } from 'Api/UCRM/UcrmApi';
import { ConfirmationModal, ConfirmationModalOperationType } from 'Components/Modal/ConfirmationModal/ConfirmationModal';
import { Text } from 'Components/Text/Text';
import { FolderVersion } from 'Models/Folders';

export interface DeleteFolderModalProps {
    moduleApi: ClientTPRMApi | ClientUcrmApi;
    folder: FolderVersion;
    hideModal: () => void;
    organizationId: string;
    onFolderDeleted: () => void;
}

export const DeleteFolderModal = (props: DeleteFolderModalProps): JSX.Element => {
    const deleteFolder = async (): Promise<string> => {
        await props.moduleApi.deleteFolder(props.organizationId, props.folder.id);
        props.onFolderDeleted();
        return 'Folder deleted.';
    };

    return (
        <ConfirmationModal operationType={ConfirmationModalOperationType.DELETE_AFTER_TYPING_TO_CONFIRM} headerText="Delete Folder" areYouSureText={`Are you sure you want to delete "${props.folder.name}"?`} performOperation={deleteFolder} hideModal={props.hideModal}>
            <Text>All documents within the folder will be deleted.</Text>
        </ConfirmationModal>
    );
};
